import jwtDecode from 'jwt-decode';

const getLastOpenedUrlKey = (sub: string) => `${sub}:last-opened-url`;

export const removeLastOpenedUrl = () => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
        const payload = jwtDecode<{ sub: string }>(accessToken);
        if (payload && payload.sub) {
            localStorage.removeItem(getLastOpenedUrlKey(payload.sub));
        }
    }
};

export const saveLastOpenedUrl = () => {
    const accessToken = localStorage.getItem('accessToken');

    if (accessToken) {
        const payload = jwtDecode<{ sub: string }>(accessToken);

        if (payload && payload.sub) {
            localStorage.setItem(getLastOpenedUrlKey(payload.sub), window.location.href);
        }
    }
};

export const getLastOpenedUrl = () => {
    const accessToken = localStorage.getItem('accessToken');
    if (accessToken) {
        const payload = jwtDecode<{ sub: string }>(accessToken);
        if (payload && payload.sub) {
            return localStorage.getItem(getLastOpenedUrlKey(payload.sub));
        }
    }
    return '';
};
